<script>
	import thumb_9Gf8QmGIC2g from '$lib/Components/Youtube/images/9Gf8QmGIC2g.jpg?w=610';

	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Awards from '$lib/PageSections/Awards/Awards.svelte';
	import CustomizeYourInsert from '$lib/PageSections/CustomizeYourInsert/CustomizeYourInsert.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';

	import caseStudySoundproofingWindowsInNyc from './images/caseStudySoundproofingWindowsInNyc.jpg';
	import caseStudySoundproofingWindowsInNyc2 from './images/caseStudySoundproofingWindowsInNyc2.jpg';
	import caseStudySoundproofingWindowsInNyc3 from './images/caseStudySoundproofingWindowsInNyc3.jpg';
</script>

<Section>
	<p>
		New York City is an incredible place, but winters are cold and it’s noisy
		all year long. Laurie Duncan and her husband live in a converted warehouse
		apartment with large windows so drafty, their shades would move in the wind.
		They could also hear traffic and late night parties from the bar across the
		street. They had to find soundproof windows in NYC to get some sleep!
	</p>
	<Image
		src={caseStudySoundproofingWindowsInNyc}
		alt="new york city apartment windows retrofitted with soundproofing Indow inserts"
	/>
	<p>
		They wanted to make their space more comfortable. Initially, though, they
		simply wanted to make their home more energy efficient by swapping out
		incandescent light bulbs for LEDs. As they saw their energy bills drop, they
		looked around for other energy-saving measures.
	</p>
	<p>
		They were staring straight through it: super-drafty windows. Their one-room,
		loft-style apartment had three huge single-pane windows in a historic,
		landmark building. Replacing them would cost a fortune.
	</p>
	<p class="text-indow-blue!">
		<em>
			“We were making such strides in our energy consumption and monetary
			outlay. We asked, what else can we do?”
		</em>
	</p>
	<p>– Laurie Duncan, NY.</p>
</Section>

<Section>
	<h2>
		<a href="/resources/soundproofing-windows">Soundproofing Windows</a> in New York
		City
	</h2>
	<p>
		So they kept researching until they found Indow window inserts, a solution
		that blocked both drafts and noise. What started as a quest for energy
		efficiency, turned into a way of making their home more comfortable.
		Soundproof windows in NYC – suddenly it didn’t seem so out of reach!
	</p>
	<Image
		src={caseStudySoundproofingWindowsInNyc2}
		alt="Indow insert blocking traffic noise: soundproof city windows"
	/>
	<p>
		Since the inserts are laser-measured to ensure a precise fit, it didn’t
		matter that the windows had settled along with the building and become
		out-of-square. Indow inserts also helped them avoid buying costly, bulky
		secondary window frames.
	</p>
	<p>
		Anywhere air can get in, noise can too. So when they blocked the drafts,
		they quieted the outside noise. So now the buses, sirens and pub goers
		across the street don’t sound like they’re inside their home.
	</p>
	<p>
		Laurie and her husband weren’t the only New Yorkers looking for a solution
		to soundproof their windows. Lauren Napier was also searching for a way to
		keep the city noise on the outside of her bedroom windows. She discovered
		Indow as a potential solution, but wondered: Do soundproof window inserts
		work? You can see in the video below that the answer is yes.
	</p>
	<Youtube
		posterImageSrc={thumb_9Gf8QmGIC2g}
		src="https://www.youtube.com/embed/9Gf8QmGIC2g"
		title="Soundproofing Windows in a New York City Apartment: Indow Customer Review"
	/>
	<p>
		Lauren’s 6-foot windows allowed a lot of traffic noise in, but as a renter,
		replacements were not an option. Like many others, she purchased Indow
		inserts to address noise issues and was pleasantly surprised to find that
		they also did a wonderful job of temperature regulation.
	</p>
	<p>
		Laurie and Lauren managed soundproof windows in NYC and blocked the cold
		window drafts at the same time. We’re grateful they tell everyone how they
		did it!
	</p>
	<Image
		src={caseStudySoundproofingWindowsInNyc3}
		alt="converted apartment fitted with Indow inserts: how to soundproof nyc windows"
	/>
</Section>
<GetAFreeEstimate backgroundColor="grey-light" />
<CustomizeYourInsert />
<Awards />
